// Simple UI state store for global (non-Redux) usage: mobile sidebar visibility
type StateListener = (state: UIState) => void;

interface UIState {
  mobileSidebarOpen: boolean;
  sidebarCollapsed: boolean;
}

let listeners: StateListener[] = [];
const state: UIState = {
  mobileSidebarOpen: false,
  sidebarCollapsed: false,
};

export function toggleMobileSidebar() {
  state.mobileSidebarOpen = !state.mobileSidebarOpen;
  listeners.forEach(l => l({ ...state }));
}

export function openMobileSidebar() {
  if (!state.mobileSidebarOpen) {
    state.mobileSidebarOpen = true;
    // Ensure sidebar expanded when opening mobile for clarity
    state.sidebarCollapsed = false;
    listeners.forEach(l => l({ ...state }));
  }
}

export function closeMobileSidebar() {
  if (state.mobileSidebarOpen) {
    state.mobileSidebarOpen = false;
    listeners.forEach(l => l({ ...state }));
  }
}

export function toggleSidebarCollapsed() {
  state.sidebarCollapsed = !state.sidebarCollapsed;
  listeners.forEach(l => l({ ...state }));
}

export function setSidebarCollapsed(value: boolean) {
  if (state.sidebarCollapsed !== value) {
    state.sidebarCollapsed = value;
    listeners.forEach(l => l({ ...state }));
  }
}

export function subscribeUI(listener: StateListener) {
  listeners.push(listener);
  // Push current state immediately
  listener({ ...state });
  return () => {
    listeners = listeners.filter(l => l !== listener);
  };
}

export function getUIState() {
  return { ...state };
}
